// Clean API helper — no React imports

import { API_BASE_URL } from "../config/apiBase";

const API_BASE = API_BASE_URL;

/**
 * Generic POST with JSON
 */
export async function postJSON(url, body = {}) {
  const res = await fetch(`${API_BASE}${url}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    let detail = "Request failed";
    try {
      const e = await res.json();
      detail = e.detail || JSON.stringify(e);
    } catch {}
    throw new Error(detail);
  }

  return res.json();
}

/**
 * Generic GET request
 */
export async function getJSON(url) {
  const res = await fetch(`${API_BASE}${url}`);
  if (!res.ok) throw new Error(`GET ${url} failed (${res.status})`);
  return res.json();
}
